import InventoryOperationsDashboardPage from '../InventoryOperationsDashboardPage';

export default InventoryOperationsDashboardPage;
